<template>

<ion-page id="contact-page">
   <ion-content >
     <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
           :style="styleOneFrame">
    <ion-item>
    <h2>I want to hear from you</h2>
    </ion-item>
    <ion-item>
      <div>
    Hi,
    <p>I've tried having a contact form on the web but every day automated bots flood it with junk. And that's with the "I'm Not A Robot" captcha thing. And I hate the: <em>identify all the photos with buses</em> 'enhancement' </p>
    <p>So my solution to all this is: <b>Just send me an Email</b></p>
    <p>I'm the only one here. Your email will come to the inbox I use all day long.</p>
    <p>Henry - henry@chessvis.com</p>
    </div>
  </ion-item>
  </div>
  </ion-content>
 </ion-page>
</template>

<script setup>

import { IonItem,IonInput,IonPage, IonContent } from '@ionic/vue';

import { ref, watch } from 'vue'
import { doStartupCheck } from '@/composables/startupCheck.js'
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';

import { availableWidthHeight } from '@/composables/screenSize'
const connectionStore = useConnectionStore()
  
const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light")
const menuTrigger = ref(0)

const styleOneFrame = ref({
   position : "absolute",
   "overflow-y" : "scroll",
   top : "0px",
   left : "100px",
   width: "100px",
   height : "100px"
 })

 const source = ref("https://www.chessvis.com/")

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] })
updateWidthHeights()

doStartupCheck(false)

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** logoff new window size",windowSizeRef.value)
    menuTrigger.value++
    updateWidthHeights()
  })
  

function updateWidthHeights() {

  const availableSpace = availableWidthHeight()
  const oneframePositionTop = availableSpace.topIndent
  const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
  const oneframeHeight = availableSpace.height - oneframePositionTop+ availableSpace.topIndent
  const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  styleOneFrame.value.height = oneframeHeight + "px"
  styleOneFrame.value.width = oneframeWidth + "px"
  styleOneFrame.value.top = oneframePositionTop + "px"
  styleOneFrame.value.left = oneframePositionLeft + "px"
}

</script>

<style scoped>

.item{
  margin:10px auto;
}

</style>